import "./BrandingComponent.scss";
import {ImageConfig, Misc} from "../../../../constants";
import React from "react";

interface BrandingComponentProps {

}

const BrandingComponent = (props: BrandingComponentProps) => {

    return (
        <div className={'branding-component'}>
            <img className={"logo-default"} src={ImageConfig.BookAppointmentLogo} alt={Misc.APP_NAME + 'Logo'}/>
        </div>
    );

};

export default BrandingComponent;
